import { BuyerFromQuery } from "lib/hooks/api/buyer/useBuyerDetailsGql";
import { BuyerDetails } from "lib/types/models";

/**
 * Maps GraphQL buyer data to the legacy BuyerDetails format
 * This utility helps maintain compatibility with existing components
 * while using the new GraphQL API
 */
export function mapGraphQLBuyerToLegacyFormat(buyerData: BuyerFromQuery): BuyerDetails {
  return {
    id: buyerData.id,
    name: buyerData.name,
    guid: buyerData.guid,
    country: buyerData.country || "",
    url: buyerData.buyerUrl || null,
    postal_code: buyerData.postalCode || null,
    address: buyerData.address || null,
    town: buyerData.town || null,
    nuts_location: buyerData.nutsLocation || null,
    category: null,
    categories:
      buyerData.categoryAssignments?.map((cat) => ({
        buyer_category_id: cat.categoryId,
        source: cat.source || "",
        parent_category_name: cat.parentCategoryName ?? null,
      })) || [],
    metadata: {
      logo_url: buyerData.logoUrl || null,
      twitter_handle: buyerData.twitterHandle || null,
    },
    is_archived: buyerData.isArchived || false,
    is_stotles_verified: buyerData.isStotlesVerified || false,
    enhanced_data: {
      oscar_category: buyerData.oscarCategory || null,
      employee_count: buyerData.employeeCount || null,
      annual_spend: buyerData.annualSpend || null,
      location_summary: buyerData.locationSummary || null,
      url: buyerData.url || buyerData.buyerUrl || null,
    },
  };
}
